import React from 'react';

import { FontAwesomeIcon } from '@appcharge/shared-ui';

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle
} from 'components/ui';

import EditLanguageForm from './components/EditLanguageForm/EditLanguageForm';
import { EditLanguageModalProps } from './EditLanguageModal.types';

import './style.scss';

const EditLanguageModal = ({
  currentLanguage,
  isOpen,
  onClose,
  onSave
}: EditLanguageModalProps) => (
  <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
    <DialogContent
      className="bg-white p-0 max-w-[800px] rounded-lg"
      onOpenAutoFocus={(e) => e.preventDefault()}
    >
      <DialogHeader className="flex flex-row items-center justify-between px-6 py-4 border-b border-base-border">
        <DialogTitle className="text-base-mutedForeground text-p-l font-normal">
          Edit Language Display Name
        </DialogTitle>
        <div className="flex items-center">
          <div className="w-px h-[24px] bg-base-border mr-[16px]" />
          <FontAwesomeIcon
            icon="fa-regular fa-xmark"
            className="w-[12px] h-[14px] cursor-pointer text-base-foreground hover:text-base-mutedForeground transition-colors"
            onClick={onClose}
          />
        </div>
      </DialogHeader>
      <div className="px-6 py-5">
        <EditLanguageForm
          selectedLanguage={currentLanguage}
          onSave={onSave}
        />
      </div>
    </DialogContent>
  </Dialog>
);

export default EditLanguageModal;
